import { Flex, Grid } from 'antd';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import MessageDisplay from './Messages/Messages';
import ConversationsList from './Conversations/Conversations';
import useConversationSocketEvents from '../../Hooks/useConversationSocketEvents';
import useSocketSubscription from '../../Hooks/useSocketSubscription';
import { Resource } from '../../Constants/socket';

const { useBreakpoint } = Grid;

const Index = () => {
    const [conversations, setConversations] = useState([]);
    const [selectedConversation, setSelectedConversation] = useState(null);
    const [showMessages, setShowMessages] = useState(false);
    const screens = useBreakpoint();

    useSocketSubscription(Resource.CONVERSATION);

    // Use the conversation socket events hook to handle real-time updates
    useConversationSocketEvents({
        setConversations,
        selectedConversation,
        setSelectedConversation
    });

    useEffect(() => {
        if (!screens.xs) {
            setShowMessages(false);
        }
    }, [screens.xs]);

    const handleConversationSelect = (conversation) => {
        setSelectedConversation(conversation);
        if (screens.xs) {
            setShowMessages(true);
        }
    };

    const handleBack = useCallback(() => {
        setShowMessages(false);
    }, [setShowMessages]);

    return (
        <Flex
            style={{
                flexGrow: 1,
                width: '100%',
                overflow: 'hidden',
                position: 'relative',
                borderRadius: 8,
                height: '100%',
                minHeight: '100%',
            }}
        >
            <div
                style={{
                    display: screens.xs && showMessages ? 'none' : 'flex',
                    flex: screens.xs ? '1 0 100%' : '0 0 33.333%',
                    overflow: 'hidden',
                    flexGrow: 1,
                    flexShrink: 0,
                }}
            >
                <ConversationsList
                    onSelectConversation={handleConversationSelect}
                    selectedId={selectedConversation?.id}
                    conversations={conversations}
                    setConversations={setConversations}
                />
            </div>
            <div
                style={{
                    display: screens.xs && !showMessages ? 'none' : 'flex',
                    flex: screens.xs ? '1 0 100%' : '0 0 66.667%',
                    position: 'relative',
                    overflow: 'hidden',
                    flexGrow: 1,
                    flexShrink: 0,
                }}
            >
                <MessageDisplay 
                    selectedConversation={selectedConversation} 
                    onBack={handleBack}
                    setConversations={setConversations} 
                    setSelectedConversation={setSelectedConversation}
                />
            </div>
        </Flex>
    );
};

export default Index;